import { forwardRef } from 'react';

import { SvgStyled } from '@sternum/web/icons/icons.styles';
import { IconProps } from '@sternum/web/icons/icons.types';

export const Trash2Icon = forwardRef<SVGSVGElement, IconProps>(function Trash2Icon(
  { color = '', height = 18, width = 18, hasCursorPointer = false, ...props },
  ref,
) {
  return (
    <SvgStyled
      ref={ref}
      width={width}
      height={height}
      viewBox="0 0 12 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      data-has-cursor-pointer={hasCursorPointer}
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M2.4026 7.72917C2.3761 7.60286 2.3486 7.47184 2.31986 7.33579C1.95227 5.59563 2.23628 4.87441 2.63399 4.52398C3.10004 4.11335 4.06466 3.86722 5.94997 3.86722C7.83529 3.86722 8.79991 4.11335 9.26596 4.52398C9.66367 4.87441 9.94769 5.59563 9.58008 7.33579C9.55134 7.47185 9.52384 7.60289 9.49734 7.72921C9.34451 8.45752 9.2246 9.02899 9.08866 9.50166C8.92919 10.0561 8.77447 10.3695 8.60588 10.5671C8.33572 10.8837 7.83257 11.1328 5.94997 11.1328C4.06738 11.1328 3.56422 10.8837 3.29406 10.5671C3.12547 10.3695 2.97075 10.0561 2.81128 9.50166C2.67534 9.02898 2.55543 8.4575 2.4026 7.72917ZM1.46849 7.88732C1.44217 7.76182 1.4151 7.63275 1.38706 7.5C0.626581 3.9 2.19241 3 5.94997 3C9.70754 3 11.2734 3.9 10.5129 7.5C10.4848 7.63276 10.4578 7.76185 10.4315 7.88735C9.74405 11.1652 9.56896 12 5.94997 12C2.33097 12 2.15589 11.1651 1.46849 7.88732Z"
        fill={color || 'currentColor'}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M4.04999 5.56639C4.31232 5.56639 4.52498 5.76052 4.52498 6V9C4.52498 9.23948 4.31232 9.43361 4.04999 9.43361C3.78765 9.43361 3.57499 9.23948 3.57499 9V6C3.57499 5.76052 3.78765 5.56639 4.04999 5.56639ZM5.94997 5.56639C6.21231 5.56639 6.42497 5.76052 6.42497 6V9C6.42497 9.23948 6.21231 9.43361 5.94997 9.43361C5.68764 9.43361 5.47498 9.23948 5.47498 9V6C5.47498 5.76052 5.68764 5.56639 5.94997 5.56639ZM7.84996 5.56639C8.11229 5.56639 8.32495 5.76052 8.32495 6V9C8.32495 9.23948 8.11229 9.43361 7.84996 9.43361C7.58763 9.43361 7.37496 9.23948 7.37496 9V6C7.37496 5.76052 7.58763 5.56639 7.84996 5.56639Z"
        fill={color || 'currentColor'}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M6.89994 1.10148C8.64914 1.23402 9.82401 1.71821 10.4957 2.14377C10.7112 2.28031 10.7647 2.55048 10.6151 2.74722C10.4656 2.94396 10.1696 2.99277 9.95409 2.85623C9.33783 2.46581 8.05267 1.93361 5.94995 1.93361C3.83986 1.93361 2.51906 2.46909 1.95759 2.84851C1.74674 2.99099 1.44929 2.95047 1.2932 2.75799C1.13712 2.56551 1.18152 2.29397 1.39236 2.15149C2.03601 1.71653 3.24476 1.23334 4.99995 1.10132V0.43361C4.99995 0.194134 5.21262 0 5.47495 0H6.42494C6.68728 0 6.89994 0.194134 6.89994 0.43361V1.10148Z"
        fill={color || 'currentColor'}
      />
    </SvgStyled>
  );
});
